var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "dsf-datagrid", staticClass: "old-grid ds_control" },
    [
      _c(
        "div",
        { ref: "fixedbox", staticClass: "fixed" },
        [_vm._t("search")],
        2
      ),
      _c(
        "div",
        {
          ref: "list",
          staticClass: "list-box",
          style: { height: "calc(100% - " + _vm.fixedHeight + "rem)" },
          on: {
            "&scroll": function ($event) {
              return _vm.watchScroll.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "van-pull-refresh",
            {
              attrs: { disabled: !_vm.hasRefresh },
              on: { refresh: _vm.onRefresh },
              model: {
                value: _vm.refreshing,
                callback: function ($$v) {
                  _vm.refreshing = $$v
                },
                expression: "refreshing",
              },
            },
            [
              _vm.getted && _vm.data.length > 0
                ? _c(
                    "van-list",
                    {
                      ref: "list",
                      class: { dimidiate: _vm.col != 1 },
                      style: { margin: _vm.marginToRem },
                      attrs: {
                        finished: _vm.finished,
                        "finished-text": "没有更多了",
                        "immediate-check": false,
                      },
                      on: { load: _vm.onLoad },
                    },
                    [
                      _c(
                        "div",
                        {
                          style: {
                            padding: _vm.paddingToRem,
                            "background-color": _vm.backgroundColor,
                          },
                        },
                        [
                          _vm.topData.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "top-item",
                                  style: { margin: _vm.topMarginToRem },
                                },
                                [
                                  _c(
                                    "van-swipe",
                                    {
                                      staticClass: "news-swipe",
                                      attrs: {
                                        autoplay: 3000,
                                        "indicator-color": "white",
                                      },
                                    },
                                    _vm._l(
                                      _vm.topData,
                                      function (item, $index) {
                                        return _c(
                                          "van-swipe-item",
                                          { key: $index },
                                          [_vm._t("top", null, { data: item })],
                                          2
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._l(_vm.normalData, function (item, $index) {
                            return _c(
                              "div",
                              {
                                key: $index,
                                staticClass: "item",
                                style: {
                                  width:
                                    _vm.col == 1 ? "auto" : 100 / _vm.col + "%",
                                },
                              },
                              [_vm._t("default", null, { data: item })],
                              2
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.getted && _vm.data.length == 0
                ? _c(
                    "div",
                    { staticClass: "no-data" },
                    [_c("van-empty", { attrs: { description: "暂无数据" } })],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }